import { useEffect, useState } from 'react'
import { Helmet } from 'react-helmet-async'
import { mixOther } from 'api/mixOther'



type About = {
    meta_title: string;
    meta_description: string;
    meta_keywords: string;
    des_lang_vi: string;
};

export default function DoiTra() {

    const [about, setAbout] = useState<About | null>(null)

    useEffect(() => {
        const loadOther = async () => {
            const res = await mixOther("sshotro", "vi")
            if (!res?.status || !res.data?.json) {
                return;
            }

            try {
                const parsed = JSON.parse(res.data.json);
                setAbout((prev) => ({ ...prev, ...parsed }));
            } catch (error) {
                console.error("Failed to parse setting JSON:", error);
            }
        };

        loadOther();
    }, [])

    return (
        <>
            <Helmet>
                <title>{about?.meta_title || 'Chính sách đổi trả - Dược Tâm Hạnh'}</title>
                {about?.meta_description && <meta name="description" content={about.meta_description} />}
                {about?.meta_keywords && <meta name="keywords" content={about.meta_keywords} />}
            </Helmet>
            <div className="container mx-auto px-0 space-y-4">
                <div className="w-full mx-auto py-8">
                    <div className="bg-gray-50 rounded-xl p-6" dangerouslySetInnerHTML={{ __html: about?.des_lang_vi || '' }}>
                        {/* <h1 className="styles_title__Gtg9D">Điều khoản sử dụng</h1>
                        <ol className="space-y-3 text-sm text-gray-600">
                            <li><b>1.1 </b> Chào mừng bạn đến với nền tảng thuocsi.vn (bao gồm website và ứng dụng di động thuocsi.vn) được được vận hành bởi Công ty TNHH Buymed và các công ty liên kết (gọi chung là, "thuocsi.vn", "chúng tôi", hay "của chúng tôi"), vui lòng đọc kỹ các Điều Khoản Dịch Vụ dưới đây và Quy Chế Hoạt Động Sàn Giao Dịch Thương Mại Điện Tử thuocsi.vn để hiểu rõ quyền lợi và nghĩa vụ hợp pháp của mình đối với thuocsi.vn và các công ty liên kết và công ty con của thuocsi.vn. “Dịch Vụ” chúng tôi cung cấp hoặc sẵn có bao gồm: (a) Website thương mại điện tử thuocsi.vn (“Sàn TMĐT”), (b) Các dịch vụ được cung cấp bởi Sàn TMĐT và bởi phần mềm dành cho khách hàng của thuocsi.vn có sẵn trên Sàn TMĐT, và (c) tất cả các thông tin, đường dẫn, tính năng, dữ liệu, văn bản, hình ảnh, biểu đồ, âm nhạc, âm thanh, video, tin nhắn, tags, nội dung, chương trình, phần mềm, ứng dụng dịch vụ (bao gồm bất kỳ ứng dụng dịch vụ di động nào) hoặc các tài liệu khác có sẵn trên Sàn TMĐT hoặc các dịch vụ liên quan đến Sàn TMĐT (“Nội Dung”). Bất kỳ tính năng mới nào được bổ sung hoặc mở rộng đối với Dịch Vụ đều thuộc phạm vi điều chỉnh của Điều Khoản Dịch Vụ này. Điều Khoản Dịch Vụ này điều chỉnh việc bạn sử dụng Dịch Vụ cung cấp bởi thuocsi.vn.</li>
                            <li><b>1.2 </b> Dịch Vụ bao gồm dịch vụ sàn giao dịch trực tuyến nhằm kết nối và mang đến cơ hội kinh doanh cho khách hàng (“Khách Hàng”) và nhà bán hàng (“Nhà Bán Hàng”) (gọi chung là “Người Sử Dụng” hoặc “Các Bên”). Các Bên liên quan đến giao dịch mua bán sẽ chịu trách nhiệm đối với hợp đồng mua bán giữa họ, việc đăng bán hàng hóa, bảo hành sản phẩm và các vấn đề tương tự. thuocsi.vn không can thiệp vào các giao dịch mua bán giữa những Người Sử Dụng với nhau. thuocsi.vn có thể hoặc không sàng lọc trước Người Sử Dụng hoặc Nội Dung hoặc bất kỳ thông tin nào được cung cấp bởi Người Sử Dụng nhưng thuocsi.vn bảo lưu quyền loại bỏ bất cứ Nội Dung hoặc thông tin nào trên Sàn TMĐT theo Mục 6.4 bên dưới. Lưu ý, thuocsi.vn sẽ là bên trung gian quản lý tình trạng hàng hóa và mua bán giữa Khách Hàng và Nhà Bán Hàng và quản lý vấn đề vận chuyển hàng hoá.</li>
                            <li><b>1.3 </b> Trước khi trở thành Khách Hàng hoặc Nhà Bán Hàng của Sàn TMĐT, Người Sử Dụng cần đọc và chấp nhận mọi điều khoản và điều kiện được quy định hoặc dẫn chiếu đến Điều Khoản Dịch Vụ này và Chính Sách Bảo Mật.</li>
                            <li><b>1.4 </b> Kiểm tra giỏ hàng và tiến hành thanh toán.</li>
                        </ol> */}
                    </div>
                </div>
            </div>
        </>
    )
}
